// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (min-width:900px) {
    .siz{
        font-size: 5.5rem;
        line-height: 125px;
    }
    .divp{
        padding-top: 30px;
        padding-bottom: 50px;
        margin-top: 50px;
    }
    .sizp{
        font-size: 2.1rem;
    }
}
@media screen and (min-width:390px) and (max-width:899px) {
    .siz{
        font-size: 2.5rem;
        line-height: 55px;
    }
    .divp{
        padding-top: 30px;
        padding-bottom: 30px;
        margin-top: 50px;
    }
    .sizp{
        font-size: 1.3rem;
    }
}

@media screen and (max-width:389px) {
    .siz{
        font-size: 2.2rem;
        line-height: 55px;
    }
    .divp{
        padding-top: 30px;
        padding-bottom: 30px;
        margin-top: 50px;
    }
    .sizp{
        font-size: 1.1rem;
    }
}

.h1bubble {
    background: linear-gradient(to right, #ff9102,#ffe4c2 );
    /* -webkit-background-clip: text; */
    /* background-clip: text; */
    /* -webkit-text-fill-color: transparent; */
    text-wrap: nowrap;
    color:black;
    text-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);
    box-shadow: 2px 5px 5px rgba(0, 0, 0, 0.5);
    padding-left: 30px;
    padding-right: 30px;
}
.h1bubble2 {
    background: linear-gradient(to right, #84C5FF,#edf7ff );
    /* -webkit-background-clip: text; */
    /* background-clip: text; */
    /* -webkit-text-fill-color: transparent; */
    color:black;
    text-wrap: nowrap;
    text-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);
    box-shadow: 2px 5px 5px rgba(0, 0, 0, 0.5);
    padding-left: 30px;
    padding-right: 30px;
}
.h1bubble3 {
    background: linear-gradient(to right, #70ff02,#deffc5 );
    text-wrap: nowrap;
    /* -webkit-background-clip: text; */
    /* background-clip: text; */
    /* -webkit-text-fill-color: transparent; */
    color:black;
    text-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);
    box-shadow: 2px 5px 5px rgba(0, 0, 0, 0.5);
    padding-left: 30px;
    padding-right: 30px;
}`, "",{"version":3,"sources":["webpack://./src/Home/NewBanner.css"],"names":[],"mappings":"AAAA;IACI;QACI,iBAAiB;QACjB,kBAAkB;IACtB;IACA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;AACJ;AACA;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;IACA;QACI,iBAAiB;QACjB,oBAAoB;QACpB,gBAAgB;IACpB;IACA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI,uDAAuD;IACvD,mCAAmC;IACnC,2BAA2B;IAC3B,0CAA0C;IAC1C,iBAAiB;IACjB,WAAW;IACX,2CAA2C;IAC3C,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,uDAAuD;IACvD,mCAAmC;IACnC,2BAA2B;IAC3B,0CAA0C;IAC1C,WAAW;IACX,iBAAiB;IACjB,2CAA2C;IAC3C,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,uDAAuD;IACvD,iBAAiB;IACjB,mCAAmC;IACnC,2BAA2B;IAC3B,0CAA0C;IAC1C,WAAW;IACX,2CAA2C;IAC3C,0CAA0C;IAC1C,kBAAkB;IAClB,mBAAmB;AACvB","sourcesContent":["@media screen and (min-width:900px) {\n    .siz{\n        font-size: 5.5rem;\n        line-height: 125px;\n    }\n    .divp{\n        padding-top: 30px;\n        padding-bottom: 50px;\n        margin-top: 50px;\n    }\n    .sizp{\n        font-size: 2.1rem;\n    }\n}\n@media screen and (min-width:390px) and (max-width:899px) {\n    .siz{\n        font-size: 2.5rem;\n        line-height: 55px;\n    }\n    .divp{\n        padding-top: 30px;\n        padding-bottom: 30px;\n        margin-top: 50px;\n    }\n    .sizp{\n        font-size: 1.3rem;\n    }\n}\n\n@media screen and (max-width:389px) {\n    .siz{\n        font-size: 2.2rem;\n        line-height: 55px;\n    }\n    .divp{\n        padding-top: 30px;\n        padding-bottom: 30px;\n        margin-top: 50px;\n    }\n    .sizp{\n        font-size: 1.1rem;\n    }\n}\n\n.h1bubble {\n    background: linear-gradient(to right, #ff9102,#ffe4c2 );\n    /* -webkit-background-clip: text; */\n    /* background-clip: text; */\n    /* -webkit-text-fill-color: transparent; */\n    text-wrap: nowrap;\n    color:black;\n    text-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);\n    box-shadow: 2px 5px 5px rgba(0, 0, 0, 0.5);\n    padding-left: 30px;\n    padding-right: 30px;\n}\n.h1bubble2 {\n    background: linear-gradient(to right, #84C5FF,#edf7ff );\n    /* -webkit-background-clip: text; */\n    /* background-clip: text; */\n    /* -webkit-text-fill-color: transparent; */\n    color:black;\n    text-wrap: nowrap;\n    text-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);\n    box-shadow: 2px 5px 5px rgba(0, 0, 0, 0.5);\n    padding-left: 30px;\n    padding-right: 30px;\n}\n.h1bubble3 {\n    background: linear-gradient(to right, #70ff02,#deffc5 );\n    text-wrap: nowrap;\n    /* -webkit-background-clip: text; */\n    /* background-clip: text; */\n    /* -webkit-text-fill-color: transparent; */\n    color:black;\n    text-shadow: 5px 5px 5px rgba(0, 0, 0, 0.2);\n    box-shadow: 2px 5px 5px rgba(0, 0, 0, 0.5);\n    padding-left: 30px;\n    padding-right: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
